module.exports = __webpack_public_path__ + "static/img/img28.6904572.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img28.png
// module id = HbPQ
// module chunks = 1